import Vue from 'vue'
import VueI18n from 'vue-i18n'
import localeEle from 'element-ui/lib/locale';
import { locale,i18n as iviewLocale, Page } from 'view-design';
import enLocale_ele from 'element-ui/lib/locale/lang/en'
import zhLocale_ele from 'element-ui/lib/locale/lang/zh-CN'

import enLocale_iview from 'view-design/dist/locale/en-US';
import zhLocale_iview from 'view-design/dist/locale/zh-CN';

Vue.use(VueI18n)

import cn from './I18n_ZH'
import en from './I18n_EN'
// 实现自定义格式
class CustomFormatter {
  constructor (options) {
    // ...
  }

  //
  // 插值
  //
  // @param {string} 信息
  //   列表或具名格式的字符串。
  //   例如：
  //   - 具名格式：'Hi {name}'
  //   - 列表格式：'Hi {0}'
  //
  // @param {Object | Array} 值
  //   `message` 插值的值
  //   使用 `$t`， `$tc` 和 `i18n` 函数式组件传递值。
  //   e.g.
  //   - $t('hello', { name: 'kazupon' }) -> 传递值：Object `{ name: 'kazupon' }`
  //   - $t('hello', ['kazupon']) -> 传递值：Array `['kazupon']`
  //   - `i18n` 函数式组件 (组件插值)
  //     <i18n path="hello">
  //       <p>kazupon</p>
  //       <p>how are you?</p>
  //     </i18n>
  //     -> 传递值：Array (included VNode):
  //        `[VNode{ tag: 'p', text: 'kazupon', ...}, VNode{ tag: 'p', text: 'how are you?', ...}]`
  //
  // @return {Array<any>}
  //   插值，你需要返回以下内容：
  //   - 当使用 `$t` 或 `$tc` 数组中应该是字符串。
  //   - 当使用 `i18n` 函数式组件时 数组中应包含 VNode 对象。
  //
  interpolate (message, values) {
    // 在这里实现插值逻辑
    // ...

    // 返回插值数组
    return ['resolved message string']
  }
}

if (!localStorage.getItem('locale')){
  localStorage.setItem('locale','en')
}
// 注册 `formatter` 选项
 const i18n = new VueI18n({
  locale: localStorage.getItem('locale'), // 'en-US'
  // formatter: new CustomFormatter(/* 这里是构造函数选项 */),
  messages: {
    'en': Object.assign(en, enLocale_ele),
    'cn': Object.assign(cn, zhLocale_ele)
  }
})

localeEle.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换
locale( localStorage.getItem('locale') === 'cn' ? zhLocale_iview : enLocale_iview)
// iviewLocale((key, value) => i18n.t(key, value))

// Vue.config.lang =
// 'en-US';
// Vue.locale('en-US', en);
// Vue.locale('zh-CN', zh);

export default i18n
